import { faIcon } from "@utils/faIcon"

import { ExtraTouchArea } from "@particles/index"

import { Icon } from ".."
import styles from "./HintTrigger.module.scss"
import { HintTriggerProps } from "./HintTrigger.types"

const iconSize = 14
const defaultIcon = faIcon({ name: "circle-info", style: "solid" })

export default function HintTrigger(props: HintTriggerProps) {
    const { icon = defaultIcon } = props

    return (
        <ExtraTouchArea extraTouchArea={9}>
            <div className={styles.base}>
                <Icon icon={icon} size={iconSize} container="fixedHeight" />
            </div>
        </ExtraTouchArea>
    )
}
